module.exports = __webpack_public_path__ + "img/cq3-title-icon.bb34c2ea.png";